import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewal-approval',
  templateUrl: './renewal-approval.component.html',
  styleUrls: ['./renewal-approval.component.css']
})
export class RenewalApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/renewal-approval/renewal-approval.component.ts